import { CommunicationTemplateType } from "@bbj-types/communication/enum";
import { type InferType, array, object, string } from "yup";

export const sendSocialOfferValidationSchema = object().shape({
  mode: string().oneOf(
    [CommunicationTemplateType.EMAIL, CommunicationTemplateType.SMS],
    "Le mode de communication est requis"
  ),
  template: string().nullable(),
  templateType: string().optional(),
  emails: array(
    object({
      address: string().email("L'email est invalide.").required("L'email est requis"),
      name: string().required("Le nom est requis"),
    }).required()
  )
    .default([])
    .when("mode", {
      is: CommunicationTemplateType.EMAIL,
      then: (schema) => schema.min(1, "Au moins un destinataire est requis"),
    }),
  cc: array(string().email("L'email est invalide.").required()).optional(),
  subject: string()
    .default("")
    .when("mode", {
      is: CommunicationTemplateType.EMAIL,
      then: (schema) => schema.min(1, "Un objet est requis."),
    }),
  attachments: array(object({ _id: string().required() })).optional(),
  content: string().required("Le contenu ne peut être vide."),
});

export type TSendSocialOfferResolver = InferType<typeof sendSocialOfferValidationSchema>;
